// ======================================================================
// File Name       : AdaptiveMetaContainer
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { connect } from 'react-redux';
import { reduxForm, isInvalid, getFormValues, change } from 'redux-form';
import { Form } from 'react-bootstrap';
import Header from '../../components/Header';
import MessageSearch from '../../components/MessageSearch';
import AdaptiveBatchImport from '../../components/adaptive/AdaptiveBatchImport';
import AdaptiveBatchHistory from '../../components/adaptive/AdaptiveBatchHistory';
import * as AdaptiveAction from '../../actions/AdaptiveAction';
import { showExportCSVSuccessMessage, handleDownload, hasProperty } from '../../utils/index';
import * as ImportUtils from '../../utils/ImportUtils';
import DialogConfirm from '../../components/DialogConfirm';
import * as MessageTemplate from '../../constants/MessageTemplate';
import { RETURN_MAX_NUM } from '../../constants/index';

class AdaptiveMetaContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showExportModal: false,
      showImportModal: false,
      fileUpload: null,
      fileName: '',
      fileSize: 0,
    };
    this.pathOptions = {};
    this.importAdaptiveMeta = this.importAdaptiveMeta.bind(this);
    this.exportAdaptiveMeta = this.exportAdaptiveMeta.bind(this);
    this.onExportDialogOk = this.onExportDialogOk.bind(this);
    this.onExportDialogCancel = this.onExportDialogCancel.bind(this);
    this.onImportDialogOk = this.onImportDialogOk.bind(this);
    this.onImportDialogCancel = this.onImportDialogCancel.bind(this);
    this.getStartEndData = this.getStartEndData.bind(this);
    this.handleSortState = this.handleSortState.bind(this);
    this.searchData = this.searchData.bind(this);
    this.onSearchBtnClick = this.onSearchBtnClick.bind(this);
    this.handleDownload = this.handleDownload.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
  }

  componentWillMount() {
    const { authedUser } = this.props;

    if (!authedUser || !authedUser.institutionId) {
      return;
    }

    const path = ImportUtils.getAction(this.props.match.url);
    this.pathOptions = {
      ...this.pathOptions,
      csvSamplePath: path.csvSamplePath,
    };
    const param = {
      startPosition: 0,
      returnMaxNum: RETURN_MAX_NUM,
      institutionId: authedUser.institutionId,
    };
    this.props.dispatch(AdaptiveAction.getAdaptiveMetaImportList(param));
  }

  exportAdaptiveMeta() {
    const { authedUser } = this.props;

    if (!authedUser || !authedUser.institutionId) {
      return;
    }
    this.setState({
      showExportModal: true,
    });
  }

  onExportDialogOk() {
    this.setState(
      {
        showExportModal: false,
      },
      () => {
        const { authedUser } = this.props;
        if (!authedUser || !authedUser.institutionId) {
          return;
        }
        const param = {
          institutionId: authedUser.institutionId,
        };
        this.props.dispatch(AdaptiveAction.exportAdaptiveMeta(param)).then(() => {
          showExportCSVSuccessMessage();
        });
      },
    );
  }

  onExportDialogCancel() {
    this.setState({
      showExportModal: false,
    });
  }

  importAdaptiveMeta() {
    const { formValues, authedUser } = this.props;
    if (!formValues || !this.state.fileUpload) {
      return;
    }
    if (!authedUser || !authedUser.institutionId) {
      return;
    }
    this.setState({
      showImportModal: true,
    });
  }

  onImportDialogOk() {
    this.setState(
      {
        showImportModal: false,
      },
      () => {
        const { formValues, authedUser } = this.props;
        if (!formValues || !this.state.fileUpload) {
          return;
        }
        if (!authedUser || !authedUser.institutionId) {
          return;
        }

        const param = {};
        param.institutionId = authedUser.institutionId;
        param.uploadFile = this.state.fileUpload;
        this.props.dispatch(AdaptiveAction.importAdaptiveMeta(param)).then(() => {
          this.searchData(0, null);
        });
      },
    );
  }

  onImportDialogCancel() {
    this.setState({
      showImportModal: false,
    });
  }

  getStartEndData(startPosition) {
    const { invalid } = this.props;
    if (invalid) return;
    this.searchData(startPosition);
  }

  handleSortState(column) {
    const { invalid } = this.props;
    if (invalid) return;
    this.searchData(null, column);
  }

  searchData(startPosition, column) {
    const { authedUser } = this.props;

    if (!authedUser || !authedUser.institutionId) {
      return;
    }
    const param = {
      startPosition: 0,
      returnMaxNum: RETURN_MAX_NUM,
      institutionId: authedUser.institutionId,
    };

    if (!isNaN(parseInt(startPosition, 10))) {
      param.startPosition = startPosition;
    }
    if (column && Object.keys(column).length) {
      param.ascendingDescendingSort = column.sortState;
      param.importSortType = column.sortBy;
    }
    this.props.dispatch(AdaptiveAction.getAdaptiveMetaImportList(param));
  }

  onSearchBtnClick() {
    const { invalid } = this.props;
    if (invalid) return;
    this.props.change('startPosition', 0);
    this.props.change('importSortType', null);
    this.searchData(0, null);
  }

  handleDownload(url, fileName) {
    return handleDownload(url, fileName);
  }

  // sprint_20230403-UT-001 START
  handleFileChange(event, name) {
    if (event.target.files.length !== 0) {
      const fileName = event.target.files[0].name;
      const fileSize = event.target.files[0].size;
      this.setState({
        fileUpload: event.target.files[0],
        fileName,
        fileSize,
      });
      document.getElementById(name).value = '';
    }
  }
  // sprint_20230403-UT-001 END

  render() {
    const { recordNum, importResultList, formValues } = this.props;
    const { fileUpload } = this.state;
    let disabled = false;
    let fileName = '';
    let fileSize = 0;
    if (!formValues || !fileUpload) {
      disabled = true;
    } else {
      fileName = this.state.fileName;
      fileSize = this.state.fileSize;
    }
    return (
      <div>
        <Header name="マスタ/メタデータ管理" />
        <Form
          onSubmit={(event) => {
            event.preventDefault();
            this.importAdaptiveMeta();
          }}
          className='form-horizontal'
        >
          <AdaptiveBatchImport
            {...formValues}
            {...this.pathOptions}
            importAdaptiveMeta={this.importAdaptiveMeta}
            exportAdaptiveMeta={this.exportAdaptiveMeta}
            disabled={disabled}
            fileName={fileName}
            fileSize={fileSize}
            changeFile={this.handleFileChange} // sprint_20230403-UT-001
          />
          <AdaptiveBatchHistory
            {...formValues}
            recordNum={recordNum}
            importResultList={importResultList}
            getStartEndData={this.getStartEndData}
            handleSortState={this.handleSortState}
            onSearchBtnClick={this.onSearchBtnClick}
            onClickDownload={this.handleDownload}
          />
        </Form>
        <DialogConfirm
          showModal={this.state.showExportModal}
          onCancel={this.onExportDialogCancel}
          mdSize={this.mdSize}
          content={MessageTemplate.BULK_EXPORT}
          onOK={this.onExportDialogOk}
        />
        <DialogConfirm
          showModal={this.state.showImportModal}
          onCancel={this.onImportDialogCancel}
          mdSize={this.mdSize}
          content={MessageTemplate.BULK_IMPORT}
          onOK={this.onImportDialogOk}
        />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { recordNum, importResultList } = state.adaptive;
  const { authedUser } = state.authed;
  return {
    recordNum,
    importResultList,
    authedUser,
    formValues: getFormValues('adaptiveMetaForm')(state),
    invalid: isInvalid('adaptiveMetaForm')(state),
    initialValues: { startPosition: 0 },
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: 'adaptiveMetaForm',
    touchOnChange: true,
  })(AdaptiveMetaContainer),
);
